// extracted by mini-css-extract-plugin
module.exports = {"padding_element_right":"IconLink_padding_element_right__33oeL","padding_element_left":"IconLink_padding_element_left__frXjC"};